import React, { useState } from "react";
import "./Msign.css";
import usergif from "../assests/vendor.png";
import usergifs from "../assests/signup.png";
import van from "../assests/van.png";
import vans from "../assests/van2.png";
import bgm from "../assests/bgm.png";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function Merchantsign() {
  const [isSignIn, setIsSignIn] = useState(true);
  const [msignup, setMsignup] = useState({
    name: "",
    phone: "",
    email: "",
    gstno: "",
    address: "",
    password: "",
    confirmpassword: "",
  });

  const [msignin, setMsignin] = useState({
    name: "",
    password: "",
  });

  const navigate = useNavigate();

  const handlesingup = async () => {
    const { name, phone, email, address, gstno, password, confirmpassword } =
      msignup;

    if (
      !name ||
      !phone ||
      !email ||
      !address ||
      !gstno ||
      !password ||
      !confirmpassword
    ) {
      toast.error("Please fill in all the fields");
      return;
    }

    if (password !== confirmpassword) {
      toast.error("Passwords do not match");
      return;
    }

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/signup.php`;
    const formData = new FormData();
    formData.append("name", name);
    formData.append("phone_no", phone);
    formData.append("email", email);
    formData.append("address", address);
    formData.append("gst_no", gstno);
    formData.append("password", password);
    formData.append("format", "vendor");

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.message === "User created successfully") {
        setMsignup({
          name: "",
          phone: "",
          email: "",
          gstno: "",
          address: "",
          password: "",
          confirmpassword: "",
        });
        toast.success("Vendor created successfully");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const handlesingin = async () => {
    const { name, password } = msignin;

    if (!name || !password) {
      toast.error("Please enter both username and password");
      return;
    }

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/signin.php`;
    const formData = new FormData();
    formData.append("name", name);
    formData.append("password", password);
    formData.append("format", "vendor");

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.message === "Login successful") {
        localStorage.setItem(
          "vendorData",
          JSON.stringify({
            id: data.id,
            username: data.username,
            name: data.name,
          })
        );
        setMsignin({ name: "", password: "" });
        toast.success("Logged in successfully");
        navigate("/vendor/vendordashboard");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return (
    <div className={`auth-screen ${isSignIn ? "" : "right-panel-active"}`}>
      <img src={bgm} alt="bgm" className="signidn-bg" />
      <div className="form-container sign-up-container">
        <div className="div">
          <h1 className="heading">Create Account</h1>
          <input
            type="text"
            placeholder="Name"
            required
            value={msignup?.name}
            onChange={(e) =>
              setMsignup((pv) => ({ ...pv, name: e.target.value }))
            }
          />
          <input
            type="text"
            placeholder="Phone Number"
            required
            value={msignup?.phone}
            onChange={(e) =>
              setMsignup((pv) => ({ ...pv, phone: e.target.value }))
            }
          />
          <input
            type="email"
            placeholder="Email"
            required
            value={msignup?.email}
            onChange={(e) =>
              setMsignup((pv) => ({ ...pv, email: e.target.value }))
            }
          />
          <input
            type="text"
            placeholder="GST No."
            required
            value={msignup?.gstno}
            onChange={(e) =>
              setMsignup((pv) => ({ ...pv, gstno: e.target.value }))
            }
          />
          <input
            type="text"
            placeholder="Address"
            required
            value={msignup?.address}
            onChange={(e) =>
              setMsignup((pv) => ({ ...pv, address: e.target.value }))
            }
          />
          <input
            type="password"
            placeholder="Password"
            required
            value={msignup?.password}
            onChange={(e) =>
              setMsignup((pv) => ({ ...pv, password: e.target.value }))
            }
          />
          <input
            type="password"
            placeholder="Confirm Password"
            required
            value={msignup?.confirmpassword}
            onChange={(e) =>
              setMsignup((pv) => ({ ...pv, confirmpassword: e.target.value }))
            }
          />
          <button className="mbutton" onClick={handlesingup}>Sign Up</button>
        </div>
      </div>

      <div className="form-container sign-in-container">
        <div className="div">
          <h1 className="heading">Sign in</h1>
          <input
            type="text"
            placeholder="Email, Username or Phone Number"
            required
            value={msignin?.name}
            onChange={(e) =>
              setMsignin((pv) => ({ ...pv, name: e.target.value }))
            }
          />
          <input
            type="password"
            placeholder="Password"
            required
            value={msignin?.password}
            onChange={(e) =>
              setMsignin((pv) => ({ ...pv, password: e.target.value }))
            }
          />
          <button className="mbutton" onClick={handlesingin}>Sign In</button>
        </div>
      </div>

      <div className={`van-wrapper ${isSignIn ? "" : "slide-right"}`}>
        <img src={vans} alt="Delivery Van" className="van-img" />
      </div>

      <div className={`van-wrappers ${isSignIn ? "" : "slide-left"}`}>
        <img src={van} alt="Delivery Van 2" className="van-img" />
      </div>

      <div className="overlay-container">
        <div className="overlay">
          <img src={usergif} alt="Vendorsignin" className="vendorsignin" />
          <div className="overlay-panel overlay-left">
            <h1>Welcome Back!</h1>
            <p>To keep connected with us, please login with your info</p>
            <button className="mbutton ghost" onClick={() => setIsSignIn(true)}>
              Sign In
            </button>
          </div>
          <img src={usergifs} alt="Vendorsignin" className="vendorsignup" />
          <div className="overlay-panel overlay-right">
            <h1>Hello, Friend!</h1>
            <p>Enter your details and start your journey with us</p>

            {/* <button className="mbutton ghost" onClick={() => setIsSignIn(false)}>
              Sign Up
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Merchantsign;
